import { render, staticRenderFns } from "./TplusPushRecord.vue?vue&type=template&id=12e5201a&scoped=true"
import script from "./TplusPushRecord.vue?vue&type=script&lang=js"
export * from "./TplusPushRecord.vue?vue&type=script&lang=js"
import style0 from "./TplusPushRecord.vue?vue&type=style&index=0&id=12e5201a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e5201a",
  null
  
)

export default component.exports